import {useContext} from 'react'

import PropTypes from 'prop-types'

import Button, {
  atomButtonAlignment,
  atomButtonColors,
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes
} from '@s-ui/react-atom-button'
import AtomIcon, {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'

const baseClass = 'mt-CardAlertItem'

const CardAlertItem = ({icon, hasBadge = false, onItemClick, text}) => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const wrapIcon = Icon => (
    <AtomIcon size={ATOM_ICON_SIZES.medium}>
      <Icon />
    </AtomIcon>
  )

  return (
    <Button
      alignment={atomButtonAlignment.LEFT}
      className={`${baseClass}-button`}
      color={atomButtonColors.NEUTRAL}
      design={atomButtonDesigns.FLAT}
      fullWidth={isMobile}
      isFitted
      onClick={onItemClick}
      shape={!isMobile && atomButtonShapes.CIRCULAR}
      size={!isMobile && atomButtonSizes.LARGE}
    >
      <span className={`${baseClass}-icon`}>{wrapIcon(icon)}</span>
      <span className={`${baseClass}-content`}>{text}</span>
      {hasBadge && (
        <span className={`${baseClass}-badge`}>{i18n.t('SEARCH_SAVE_ONBOARDING_LABEL_NEW').toUpperCase()}</span>
      )}
    </Button>
  )
}

CardAlertItem.displayName = 'CardAlertItem'

CardAlertItem.propTypes = {
  icon: PropTypes.node,
  hasBadge: PropTypes.bool,
  onItemClick: PropTypes.func,
  text: PropTypes.string
}

export default CardAlertItem
